<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
  <el-form-item label="房间号" >
    <el-input v-model="formLabelAlign.roomCode" size="small" placeholder="请输入房间号（必填）"></el-input>
  </el-form-item>
  <el-form-item label="单元号">
    <el-input v-model="formLabelAlign.unitNo" size="small" placeholder="请输入单元号（必填）"></el-input>
  </el-form-item>
    <el-form-item label="室号全称" >
      <el-input v-model="formLabelAlign.roomName" size="small"></el-input>
    </el-form-item>
    <el-form-item label="楼层" >
     <el-input v-model="formLabelAlign.floorNum" type="number" size="small"></el-input>
    </el-form-item>
        <el-form-item label="朝向" >
     <el-input v-model="formLabelAlign.direction" size="small"></el-input>
    </el-form-item>
        <el-form-item label="房间状态" >
     <el-select  clearable v-model="value" placeholder="请选择房间状态"  size="small" @change="RoomType" >
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    </el-form-item>
        <el-form-item label="房屋属性" >
      <el-select  clearable v-model="valueone" placeholder="请选择房屋属性"  size="small" @change="handleChange" >
        <el-option v-for="item in optionsone" :key="item.valueone" :label="item.labelone" :value="item.valueone"></el-option>
    </el-select>
    </el-form-item>
        <el-form-item label="建筑面积" >
     <el-input v-model="formLabelAlign.buildArea" type="number" placeholder="请输入建筑面积（㎡）" size="small"></el-input>
    </el-form-item>
        <el-form-item label="使用面积" >
     <el-input v-model="formLabelAlign.usageArea" type="number" placeholder="请输入使用面积（㎡）" size="small"></el-input>
    </el-form-item>
        <el-form-item label="排序号" >
     <el-input v-model="formLabelAlign.orderNum" size="small"></el-input>
    </el-form-item>
        <el-form-item label="备注信息" >
     <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PropertyTreeDialog from "../common/PropertyTreeDialog.vue";
export default {
 components: {PropertyTreeDialog},
  name: "PropertyDialog",
  data() {
    return {
      options:[{
          value: '1',
          label: '空置'
        }, {
          value: '2',
          label: '已租'
        }, {
          value: '3',
          label: '入住'
        }, {
          value: '4',
          label: '迁出'
        }],
      value: "",
     optionsone: [{valueone: '1',labelone: '使用权房'}, {valueone: '2',labelone: '保产房'},
                {valueone: '3',labelone: '商品房'}, {valueone: '4',labelone: '空房'},
                {valueone: '5',labelone: '售后公房'}, {valueone: '6',labelone: '售后公房（商）'},
                {valueone: '7',labelone: '联排别墅'}, {valueone: '8',labelone: '复式'},
                {valueone: '9',labelone: '联排'}, {valueone: '10',labelone: '公寓'},
                {valueone: '11',labelone: '独栋'}, {valueone: '12',labelone: '双拼'},
                {valueone: '13',labelone: '多层住宅'}, {valueone: '14',labelone: '高层住宅'},
                {valueone: '15',labelone: '商业用房'}, {valueone: '16',labelone: '办公用房'},
                {valueone: '17',labelone: '别墅'}, {valueone: '18',labelone: '商铺'},
                {valueone: '19',labelone: '写字楼'},],
        value: '',
        valueone: '',
        dialogVisible: false,
        title:"标题",
        labelPosition:'right',
        formLabelAlign:{},
        type:"",
        display:"",
        detection:"",
        UserDisplay:"",

        roomProperty:"",
        floorId:"",
        roomId:"",
        projectId:"",

    };
  },
  watch:{
    dialogVisible(val){
      if(val == true){
        if(this.title == "添加"){
          this.formLabelAlign = {}
          this.valueone = ""
          this.value = ""
        }else{
            for(let val of this.optionsone){
                if(val.labelone == this.roomProperty){
                    this.valueone = val.valueone
                }
            }
        }
      }
    }
  },
  methods: {
      RoomType(val){
          
      },
      handleChange(value){
          
      },
    modification(){
        if(this.title == "修改"){
            let obj = {
                "projectId":this.projectId,
                "id":this.roomId,
                "floorId":this.floorId,
                "roomName":this.formLabelAlign.roomName,
                "unitNo":this.formLabelAlign.unitNo,
                "roomCode":this.formLabelAlign.roomCode,
                "floorNum":this.formLabelAlign.floorNum,
                "direction":this.formLabelAlign.direction,
                "roomProperty":this.valueone,
                "roomStatus":this.value,
                "buildArea":this.formLabelAlign.buildArea,
                "usageArea":this.formLabelAlign.usageArea,
                "orderNum":this.formLabelAlign.orderNum,
                "remarks":this.formLabelAlign.remarks,
            }
            if(obj.roomCode != undefined || obj.roomCode != "" || obj.roomCode != null){
                if(obj.unitNo != undefined || obj.unitNo != "" || obj.unitNo != null){
                    if(obj.roomName != undefined || obj.roomName != "" || obj.roomName != null){
                        if(obj.floorNum != undefined || obj.floorNum != "" || obj.floorNum != null){
                            if(obj.roomStatus != undefined || obj.roomStatus != "" || obj.roomStatus != null){
                                if(obj.roomProperty != undefined || obj.roomProperty != "" || obj.roomProperty != null){
                                    if(obj.buildArea != undefined || obj.buildArea != "" || obj.buildArea != null){
                                        this.$http.put(this.$requestUrl.PUT_ROOM_AMEND,obj).then((res) => {
                                            let result = res.data;
                                            if (200 === result.code) {
                                            this.dialogVisible = false
                                             this.$message({
                                                type: 'success',
                                                message: '修改成功!'
                                            });
                                            this.$emit("Visible",false)
                                            } else {
                                            this.$message.error(result.msg)
                                            }
                                        }).catch(() => {
                                        this.$message.error(this.$errorMessage.SEVER_ERROR)
                                        })
                                    }else{
                                    this.$message({
                                        message: '请填写建筑面积！',
                                        type: 'warning'
                                    });
                                    }  
                                }else{
                                      this.$message({
                                message: '请选择房屋属性！',
                                type: 'warning'
                            });
                                }  
                            }else{
                                 this.$message({
                                message: '请选择房间状态！',
                                type: 'warning'
                            });
                            }                        
                        }else{
                              this.$message({
                                message: '请填写楼层！',
                                type: 'warning'
                            });
                        }
                    }else{
                     this.$message({
                    message: '请填写室号全称！',
                    type: 'warning'
                  });
                    }
                }else{
                     this.$message({
                    message: '请填写单元号！',
                    type: 'warning'
                  });
                }
            }else{
                 this.$message({
                    message: '请填写房间号！',
                    type: 'warning'
                  });
            }
        }else{
               let obj = {
                "projectId":this.projectId,
                "floorId":this.floorId,
                "roomName":this.formLabelAlign.roomName,
                "unitNo":this.formLabelAlign.unitNo,
                "roomCode":this.formLabelAlign.roomCode,
                "floorNum":this.formLabelAlign.floorNum,
                "direction":this.formLabelAlign.direction,
                "roomProperty":this.valueone,
                "roomStatus":this.value,
                "buildArea":this.formLabelAlign.buildArea,
                "usageArea":this.formLabelAlign.usageArea,
                "orderNum":this.formLabelAlign.orderNum,
                "remarks":this.formLabelAlign.remarks,
            }
              if(obj.roomCode != undefined || obj.roomCode != "" || obj.roomCode != null){
                if(obj.unitNo != undefined || obj.unitNo != "" || obj.unitNo != null){
                    if(obj.roomName != undefined || obj.roomName != "" || obj.roomName != null){
                        if(obj.floorNum != undefined || obj.floorNum != "" || obj.floorNum != null){
                            if(obj.roomStatus != undefined || obj.roomStatus != "" || obj.roomStatus != null){
                                if(obj.roomProperty != undefined || obj.roomProperty != "" || obj.roomProperty != null){
                                    if(obj.buildArea != undefined || obj.buildArea != "" || obj.buildArea != null){
                                        this.$http.post(this.$requestUrl.POST_ROOM_ADD,obj).then((res) => {
                                            let result = res.data;
                                            if (200 === result.code) {
                                            this.dialogVisible = false
                                             this.$message({
                                                type: 'success',
                                                message: '添加成功!'
                                            });
                                            this.$emit("Visible",false)
                                            } else {
                                            this.$message.error(result.msg)
                                            }
                                        }).catch(() => {
                                        this.$message.error(this.$errorMessage.SEVER_ERROR)
                                        })
                                    }else{
                                    this.$message({
                                        message: '请填写建筑面积！',
                                        type: 'warning'
                                    });
                                    }  
                                }else{
                                      this.$message({
                                message: '请选择房屋属性！',
                                type: 'warning'
                            });
                                }  
                            }else{
                                 this.$message({
                                message: '请选择房间状态！',
                                type: 'warning'
                            });
                            }                        
                        }else{
                              this.$message({
                                message: '请填写楼层！',
                                type: 'warning'
                            });
                        }
                    }else{
                     this.$message({
                    message: '请填写室号全称！',
                    type: 'warning'
                  });
                    }
                }else{
                     this.$message({
                    message: '请填写单元号！',
                    type: 'warning'
                  });
                }
            }else{
                 this.$message({
                    message: '请填写房间号！',
                    type: 'warning'
                  });
            }
        //     if(obj.name != undefined && obj.name != undefined && obj.name != ''){
        //       if(obj.code != undefined && obj.code != undefined && obj.code != ''){
        //         if(obj.orgid != undefined && obj.orgid != undefined && obj.orgid != ''){
        //            this.$http.post(this.$requestUrl.POST_PROJECT_ADD,obj).then((res) => {
        //       let result = res.data;
        //       if (200 === result.code) {
        //         this.dialogVisible = false
        //         this.$emit("Visible",false)
        //       } else {
        //         this.$message.error(result.msg)
        //       }
        //       }).catch(() => {
        //         this.$message.error(this.$errorMessage.SEVER_ERROR)
        //       })
        //         }else{
        //           this.$message({
        //             message: '请选择归属机构！',
        //             type: 'warning'
        //           });
        //         }
        //       }else{
        //          this.$message({
        //             message: '请填写项目代码！',
        //             type: 'warning'
        //           });
        //       }
        //     }else{
        //       this.$message({
        //         message: '请填写项目名称！',
        //         type: 'warning'
        //       });
        //     }

        }

    },

    handleClose(done) {
     this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
            if(this.formLabelAlign.obj == undefined){
                   let obj = {
            "areaname":"归属机构",
            "orgCode":"物业类型",
            "code":"项目代码",
            "name":"项目名称",
            "site":"地址",
            "floor":"占地面积",
            "buildArea":"建筑面积",
            "public":"公共场所面积",
            "afforest":"绿化面积",
            "way":"道路面积",
            "groundarea":"地上停车面积",
            "undergroundarea":"地下停车面积",
            "groundCar":"地上车位数",
            "undergroundCar":"地下车位数",
            "start":"开工日期",
            "userType":"竣工日期",
            "design":"设计单位",
            "exploit":"开发单位",
            "remarks":"备注信息",
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>